import React from 'react';
import './Shipping.css';
import imgss from "../../assets/images/kidss.avif";
import Footer from '../../components/Footer/Footer';
import { FaMapMarkerAlt, FaRupeeSign, FaTruck, FaShieldAlt } from 'react-icons/fa';

const shippingInfo = [
    {
        icon: <FaMapMarkerAlt />,
        text: (
            <>
                We offer <strong>free shipping</strong> on all jewelry within <strong>Udupi and Mangalore districts</strong>.
            </>
        ),
    },
    {
        icon: <FaRupeeSign />,
        text: (
            <>
                For other locations in India, charges apply — <strong>₹1000 for gold</strong> and <strong>₹400 for silver</strong>.
            </>
        ),
    },
    {
        icon: <FaTruck />,
        text: <>Charges are shown at checkout once your location is entered.</>,
    },
    {
        icon: <FaShieldAlt />,
        text: (
            <>
                All orders are <strong>securely packed and insured</strong> during transit.
            </>
        ),
    },
    {
        icon: <FaTruck />,
        text: (
            <>
                Track your order from your <strong>avnII.in account</strong> or email tracking link.
            </>
        ),
    },
];

const Shipping = () => {
    return (
        <>
            <img src={imgss} alt="Shipping Banner" className='abtimg cuim' />

            <div className="shipping-container">
                <h2 className="shipping-title">Shipping & Delivery Information</h2>

                <div className="shipping-cards">
                    {shippingInfo.map((item, index) => (
                        <div className="shipping-card" key={index}>
                            <div className="card-icon">{item.icon}</div>
                            <div className="card-text">{item.text}</div>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Shipping;
